<template>
    <YearPickerCellTrigger
        v-slot="{ yearValue }"
        :class="
            cn('ds-calendar-cell-trigger flex h-10 w-full items-center justify-center rounded-full p-0 font-normal', props.class)
        "
        v-bind="forwardedProps"
    >
        <button
            class="h-full w-full rounded-full p-0 font-normal focus:outline-none"
            type="button"
        >
            {{ yearValue }}
        </button>
    </YearPickerCellTrigger>
</template>

<script setup lang="ts">
import { cn } from '@/lib/utils';
import { reactiveOmit } from '@vueuse/core';
import type { YearPickerCellTriggerProps } from 'reka-ui';
import { YearPickerCellTrigger, useForwardProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

const props = defineProps<YearPickerCellTriggerProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<style scoped lang="scss">
@use './styles/ds-calendar-cell-trigger';
</style>
